import React from 'react';

import useTranslation from '../../hooks/useTranslation';

const AuthorizedCustomerTerms: React.FC = () => {
    const translated = useTranslation().accountDetails.addAuthorizedCustomer;

    return (
        <div className="account-terms-list">
            <h2>{translated.termsTitle}</h2>
            <p>{translated.responsibility}</p>
            <h3 className="account-terms-list__list-title">{translated.termsSharingAccountInfo}</h3>
            <ul className="account-terms-list__list">
                <li>{translated.termsSharingAccountInfoList.itemOne}</li>
                <li>{translated.termsSharingAccountInfoList.itemTwo}</li>
                <li>{translated.termsSharingAccountInfoList.itemThree}</li>
                <li>{translated.termsSharingAccountInfoList.itemFour}</li>
                <li>{translated.termsSharingAccountInfoList.itemFive}</li>
            </ul>
            <h3 className="account-terms-list__list-title">{translated.termsIncludingInfo}</h3>
            <ul className="account-terms-list__list">
                <li>{translated.termsIncludingInfoList.itemOne}</li>
                <li>{translated.termsIncludingInfoList.itemTwo}</li>
                <li>{translated.termsIncludingInfoList.itemThree}</li>
            </ul>
        </div>
    );
};

export default AuthorizedCustomerTerms;
